
import { Component, Input, computed, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryFacade, WorkspaceFacade } from '@state';

@Component({
  selector: 'app-history',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent {
  /**
   * Stable scope key for this instance (panel-level), e.g.:
   * - define.chat
   * - define.definition
   * - tickets.board
   */
  @Input({ required: true }) scopeKey!: string;

  private root = inject(WorkspaceFacade);
  private history = inject(HistoryFacade);

  private projectId = computed(() => this.root.activeProjectId());

  items = computed(() => {
    const pid = this.projectId();
    if (!pid || !this.scopeKey) return [];
    return this.history.byScope(pid, this.scopeKey)();
  });

  constructor() {
    effect(() => {
      const pid = this.projectId();
      const scope = this.scopeKey;
      if (!pid || !scope) return;
      void this.history.loadScope(pid, scope);
    });
  }
}


